import React, { Component } from 'react';
import TournamentOverlay, { Aviso } from './TournamentOverlay';

// El juez ordena un grupo que sigue empatado después de toda la cadena de desempate. Las bases de
// Catan terminan la cadena en el conteo de 3º puestos y no dicen qué hacer después: lo decide el
// juez, y el sistema guarda quién lo decidió y cuándo (queda en la bitácora).
class TiebreakModal extends Component {
    constructor(props) {
        super(props);
        this.state = { orden: props.group.participantIds.slice(), saving: false, error: null };
    }

    mover = (i, d) => {
        const orden = this.state.orden.slice();
        const j = i + d;
        if (j < 0 || j >= orden.length) return;
        [orden[i], orden[j]] = [orden[j], orden[i]];
        this.setState({ orden });
    }

    guardar = async (clear = false) => {
        this.setState({ saving: true, error: null });
        try {
            await this.props.onSave(this.state.orden, clear);
        } catch (e) {
            this.setState({ saving: false, error: e.message });
        }
    }

    render() {
        const { group, rowsById } = this.props;
        const { orden } = this.state;
        return (
            <TournamentOverlay title={`Resolver empate · puestos ${group.fromRank} a ${group.toRank}`} onClose={this.props.onClose}
                footer={(
                    <div className="d-flex align-items-center" style={{ gap: 10 }}>
                        <button type="button" className="btn btn-accent" disabled={this.state.saving} onClick={() => this.guardar(false)}>
                            {this.state.saving ? 'Guardando…' : 'Guardar este orden'}
                        </button>
                        {group.resolved ? (
                            <button type="button" className="btn btn-white" disabled={this.state.saving} onClick={() => this.guardar(true)}>
                                Borrar el orden del juez
                            </button>
                        ) : null}
                    </div>
                )}>
                <Aviso tipo="warn">
                    Estos jugadores empatan en <strong>toda</strong> la cadena de desempate. Ordenalos como decidió el juez
                    (de mejor a peor). Queda registrado con tu usuario y la hora. Si después cambia un resultado de
                    las preliminares, este orden se anula y hay que volver a decidirlo.
                </Aviso>
                {this.state.error ? <Aviso tipo="error">{this.state.error}</Aviso> : null}
                <ol style={{ paddingLeft: 22 }}>
                    {orden.map((pid, i) => {
                        const r = rowsById[pid] || {};
                        return (
                            <li key={pid} style={{ marginBottom: 6, fontSize: 13.5 }}>
                                <span className="d-inline-flex align-items-center" style={{ gap: 8 }}>
                                    <strong>{group.fromRank + i}º</strong> {r.name}
                                    <span className="text-muted" style={{ fontSize: 12 }}>
                                        {r.wins} V · {Math.round((r.raw || 0) * 100) / 100} PV
                                    </span>
                                    <button type="button" className="btn btn-sm btn-white py-0 px-1" disabled={i === 0}
                                        onClick={() => this.mover(i, -1)} aria-label="Subir">↑</button>
                                    <button type="button" className="btn btn-sm btn-white py-0 px-1" disabled={i === orden.length - 1}
                                        onClick={() => this.mover(i, 1)} aria-label="Bajar">↓</button>
                                </span>
                            </li>
                        );
                    })}
                </ol>
            </TournamentOverlay>
        );
    }
}

export default TiebreakModal;
